<div class="row">
  <!-- High Potential Employees -->
  <div class="col-md-6">
    <a [routerLink]="['/hr/employees/list']" [queryParams]="highPotentialQueryParams" class="text-decoration-none">
      <div class="card border-success hover-effect">
        <div class="card-body text-center">
          <h5 class="card-title text-success">
            <i class="fa fa-star"></i> {{ 'High Potential Employees' | translate }}
          </h5>
          <h3 class="font-weight-bold">{{ data[1] || 0 }}</h3>
          <p class="card-text text-muted">
            {{ 'Employees identified as high potential in the organization' | translate }}
          </p>
        </div>
      </div>
    </a>
  </div>

  <!-- Non-High Potential Employees -->
  <div class="col-md-6">
    <a [routerLink]="['/hr/employees/list']" [queryParams]="nonHighPotentialQueryParams" class="text-decoration-none">
      <div class="card border-secondary hover-effect">
        <div class="card-body text-center">
          <h5 class="card-title text-secondary">
            <i class="fa fa-user"></i> {{ 'Other Employees' | translate }}
          </h5>
          <h3 class="font-weight-bold">{{ data[0] || 0 }}</h3>
          <p class="card-text text-muted">
            {{ 'Employees not categorized as high potential' | translate }}
          </p>
        </div>
      </div>
    </a>
  </div>
</div>
